export const isTokenExpired = (refreshTokenDate: number): boolean => {
  const todayDateInSecs: number = Math.round(Date.now() / 1000);
  return todayDateInSecs > refreshTokenDate;
};
